import { render } from "./WidgetOrdersLatest10.vue?vue&type=template&id=455f7509&scoped=true&ts=true"
import script from "./WidgetOrdersLatest10.vue?vue&type=script&lang=ts"
export * from "./WidgetOrdersLatest10.vue?vue&type=script&lang=ts"

import "./WidgetOrdersLatest10.vue?vue&type=style&index=0&id=455f7509&scoped=true&lang=css"

import exportComponent from "/home/uat/uatdan_yrshop_admin/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-455f7509"]])

export default __exports__